import PropTypes from 'prop-types';
import { EDITOR_MODES } from '../../utilities/simpleEditorMode.js';

const EditorModeToggle = ({ editorMode, onChange, onBack }) => {
  const advancedMode = editorMode === EDITOR_MODES.ADVANCED;

  return (
    <div className="editor-mode-controls">
      <button
        className="btn btn-light btn-outline-dark editor-mode-back"
        type="button"
        onClick={onBack}
        title="Back"
        aria-label="Back"
      >
        <i className="bi bi-arrow-left" aria-hidden="true"></i>
      </button>
      <div className="editor-mode-toggle">
        <span className="editor-mode-label">Advanced Mode</span>
        <i className="bi bi-code-slash editor-mode-compact-icon" aria-hidden="true"></i>
        <button
          id="advanced-editor-mode"
          className="editor-mode-switch"
          type="button"
          role="switch"
          aria-checked={advancedMode}
          aria-label="Advanced Mode"
          onClick={() => onChange(advancedMode ? EDITOR_MODES.SIMPLE : EDITOR_MODES.ADVANCED)}
        >
          <span className="editor-mode-switch-knob" aria-hidden="true"></span>
        </button>
      </div>
    </div>
  );
};

EditorModeToggle.propTypes = {
  editorMode: PropTypes.oneOf(Object.values(EDITOR_MODES)).isRequired,
  onChange: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default EditorModeToggle;
